export const candidateDeleteSkill = ({ BeURL, id, setSkillList, showAlert, handleTopClear, setIsDeleting }) => {
    setIsDeleting(true)
            fetch(`${BeURL}/candidate-delete-skill/${id}`, {
            method: 'DELETE',
            credentials: 'include'
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    showAlert(data.message)
                    setSkillList(prev => prev.filter(skill => skill._id !== id))
                    handleTopClear()
                    setTimeout(()=>{
                        window.location.reload()
                    }, [1000])
                }
                else {
                    alert(data.message)
                }
            })
            .catch(err => {
                console.log("Error in skill delete", err)
            })
                .finally(() => setIsDeleting(false))
}
